/* ⚛ REACT */
import { useEffect, useState } from "react";

/* 🎨 STYLES */
import { Container, TextInput, InvalidText, ContainerInput, ImageIcons } from "./styles";

const Input = (props) => {
    const [isValid, setIsValid] = useState(true);
    const [color, setColor] = useState('#C7C7C7');
    const [value, setValue] = useState(props.value);

    useEffect(()=>{
        if(props.value){
            setIsValid(props.validationFunction(props.value))
            props.validationFunction(props.value) ? setColor('#006560') : setColor('#FF3939');
        }
        setValue(props.value)
    },[props])
    
    function ApplyHover (){
        color !== '#006560' && color !== '#FF3939' ? setColor('#A3A3A3') : setColor(color);
    }

    function ApplyBlur(){
        color !== '#006560' && color !== '#FF3939' ? setColor('#C7C7C7') : setColor(color);
    }

    const handleKeyDown =(e)=>{
        if(props.handleKeyDown){
            props.handleKeyDown(e);
        }
    }

    return(
        <Container $aling={props.aling} $width={props.width}>
            <ContainerInput $isvalid={isValid} $borderColor={color} className={props.className} onMouseOver={() => ApplyHover()} onMouseOut={() => ApplyBlur()}>
                {props.icon ? <ImageIcons src={props.icon} color={color}/> : <></>}
                <TextInput 
                    tabIndex={0} 
                    mask={props.mask}
                    onKeyDown={props.type === 'date' ? (e) => e.preventDefault() : handleKeyDown}
                    type= {props.type}
                    name={props.name}
                    id={props.id}
                    placeholder = {props.placeholder}
                    ref={props.innerRef}
                    value={value}
                    min={props.min}
                    max={props.max}
                    readOnly={props.readOnly}
                    step="1"
                    onChange={(e)=> {
                        if(!props.innerRef?.current?.focused || !isValid){
                            setIsValid(props.validationFunction(e.target.value))
                            props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                        }else if(!props.innerRef?.current){
                            setIsValid(props.validationFunction(e.target.value))
                            props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                        }
                        props.onchange(e.target.value)
                        setValue(e.target.value);
                    }}
                    onFocus={(e)=> {
                        props.onchange(e.target.value)
                        color !== '#FF3939' ? setColor('#006560') : setColor(color)}}
                    onBlur={(e)=> {
                        props.onchange(e.target.value)
                        setIsValid(props.validationFunction(e.target.value))
                        props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                    }}
                    $isvalid={isValid}>
                </TextInput>
            </ContainerInput>
            <InvalidText $visibility={isValid}>{props.invalidMessage}</InvalidText>
        </Container>
    )
}

export default Input;